<template>
  <div class="bu">
    <div>
      <span class="bu__title">Bulk Update</span>
      <button class="selected-chip">
        {{ selectedIdsText }}
      </button>
    </div>
    <div>
      <div>
        <base-bulk-update-fields
          :columns="columns"
          @fieldData="updateFields($event)"
        />
      </div>
      <div class="bu__controls">
        <button
          class="bu__button bu__button_submit"
          :class="{ 'submit-disabled': !selectedIds.length }"
          :disabled="!selectedIds.length"
          @click.prevent="apply()"
        >
          Apply
        </button>
        <button
          class="bu__button bu__button_cancel"
          @click="close()"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'
import { mapState } from 'vuex'
import moment from 'moment'
import { get } from 'lodash'

export default {
  name: 'BaseBulkUpdate',
  mixins: [BaseModalMixins],
  props: {
    selectedIds: {
        type: Array,
        required: true,
        default() {
          return []
        }
    },
    columns: {
        type: Array,
        required: true,
        validator (value) { 
            // Expects an Array of Objects - see features/links/Links.vue for original example
            // Should accept any Tabulator Column Component property
            // {
            //   title: String (required),
            //   options: Array (required),
            // }
            return value.every(obj => obj.title)
        }
    }
  },
  data () {
    return {
      selectedDate: null,
      form: {
        ids: this.selectedIds
      },
      pickerState: {
        visibility: 'focus'
      },
      isDatePickerOpened: false
    }
  },
  computed: {
    ...mapState('urlCensus', ['pageTypes', 'urlStatuses', 'sections', 'contentBriefStatuses', 'writingStatuses']),
    selectedIdsText () {
      let count = this.selectedIds.length
      let noneOrMultiple = count !== 1
      return `Selected ${count} Item${noneOrMultiple ? 's' : ''}`
    },
  },
  methods: {
    updateFields (fields) {
      this.form = fields.reduce((previous, current) => {
        previous[current.field] = current.value
        return previous
      }, { ...this.form })
    },
    close () {
      this.$emit('close')
    },
    apply () {
      this.$emit('apply', this.form)
    },
  }
}

</script>

<style scoped lang="scss">
  .submit-disabled {
    cursor: default !important;
    opacity: 0.4;
  }
  .selected-chip {
    border-radius: 15px;
    height: 30px;
    display: block;
    margin: 0 auto;
    background-color: $rfx-medium-march;
    color: #fff;
    outline: none;
    border: none;
    font-size: 13px;
    min-width: 120px;
    padding: 0 15px;
    margin-top: 15px;
    cursor: default;
  }
  .bu {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 40px;

    &__title {
      display: block;
      text-align: center;
      font-size: 32px;
      font-weight: 500;
    }

    &__controls {
        display: flex;
        justify-content: flex-end;
        margin-top: 30px;
    }

    &__button {
        width: 100px;
        height: 40px;
        border-radius: 4px;
        font-size: 10px;
        font-weight: 900;
        text-transform: uppercase;
        margin-left: 30px;
        border: none;
        outline: none;
        cursor: pointer;

        &_submit {
            background-color: $rfx-medium-march;
            color: #fff;
        }

        &_cancel {
            color: $rfx-dark-march;
            background-color: #fff;
        }
    }

}

</style>
